// extracted by mini-css-extract-plugin
module.exports = {"wixDropdownPanelContainer":"_20nJL","wixDropdownPanelItem":"_1XjBm","rtl":"_12Qmf"};